import { render, staticRenderFns } from "./addPhone.vue?vue&type=template&id=2912d6ea&lang=pug"
import script from "./addPhone.vue?vue&type=script&lang=js"
export * from "./addPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports